var map = {
	"./": "12cb",
	"./ar": "0654",
	"./ar.js": "0654",
	"./bn": "2057",
	"./bn.json": "2057",
	"./de": "3f28",
	"./de.js": "3f28",
	"./en": "b7d1",
	"./en.js": "b7d1",
	"./en.json": "e088",
	"./es": "a6bb",
	"./es.js": "a6bb",
	"./es.json": "d90a",
	"./fr": "19bb",
	"./fr.js": "19bb",
	"./hi": "ee1d",
	"./hi.js": "ee1d",
	"./icon/en.png": "5207",
	"./icon/es.png": "74d3",
	"./icon/idn.png": "7c0c",
	"./icon/pt.png": "8548",
	"./idn": "712f",
	"./idn.js": "712f",
	"./index": "12cb",
	"./index.js": "12cb",
	"./ko": "e8d6",
	"./ko.js": "e8d6",
	"./ms": "370f",
	"./ms.js": "370f",
	"./pt": "4d09",
	"./pt.js": "4d09",
	"./th": "4c26",
	"./th.js": "4c26",
	"./tr": "d855",
	"./tr.js": "d855",
	"./vi": "cd9d",
	"./vi.js": "cd9d",
	"./zh": "7897",
	"./zh.js": "7897"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0519";